import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const MobilePreviewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/mobile-preview") {
      navigate("/landing", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

// Phone Frame Wrapper — phone-width column on a subtle gray canvas.
// On real mobile devices (≤480px) it drops to full-screen automatically.
export const PhoneFrameWrapper = ({ children }) => {
  return (
    <div className="phone-frame-outer">
      <div className="phone-frame-inner">
        {children}
      </div>
    </div>
  );
};

export default MobilePreviewPage;
